<template>
  <require from="framework/value_converters/date-and-time"></require>

  <div class="info-box-details">
    <div class="info-box-details-caption">Panic Alerts in last 30 days</div>
    <div class="info-box-details-table">
      <table class="table table-borderless">
        <tbody>
          <tr repeat.for="panicRequest of model">
            <td style="text-align: left; cursor: pointer;" title.bind="panicRequest.user.loginName" click.delegate="panicRequest.showPanicRequest(panicRequest)"><div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 280px;">${ panicRequest.timeStamp | dateTime } ${ panicRequest.user.fullName ? panicRequest.user.fullName : panicRequest.user.loginName }</div></td>
            <td width="25px"><i class="panic-request-status ${ panicRequest.isActive ? (panicRequest.isTest ? '--active-test' : '--active') : (panicRequest.isTest ? '--inactive-test' : '--inactive') }"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
